var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:{ 'mb-2': _vm.$vuetify.breakpoint.xsOnly },attrs:{"outlined":"","pill":"","color":_vm.color,"text-color":_vm.textColor}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi mdi-thermometer")]),_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"text-subtitle-2 ml-2"},[_vm._v(_vm._s(_vm.latestTemperature)+"°C")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }